<template>
  <div class="wrapper">
    <div class="header">
      <div class="header--inner ">
        <div class="logo">
          <img :src="require('@/assets/img/jobs/social/logo.png')" alt="" />
        </div>
        <div class="menus">
          <div
            @click="toFullPageSwiper(0)"
            class="menus--item "
            :class="{ on: [0].includes(reachIndex) }"
          >
            首页
          </div>
          <div
            @click="toFullPageSwiper(1)"
            class="menus--item"
            :class="{ on: [1, 2, 3, 4].includes(reachIndex) }"
          >
            闻味松鼠
          </div>
          <div
            @click="toFullPageSwiper(5)"
            class="menus--item"
            :class="{ on: [5].includes(reachIndex) }"
          >
            社会招聘
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="swiper--wrapper">
        <swiper
          ref="fullPageSwiper"
          :style="{ width: screenWidth + 'px', height: screenHeight + 'px' }"
          :options="swiperOption"
        >
          <swiper-slide class="swiper--slide social--page1">
            <div class="video--bg">
              <div class="video--mask"></div>
              <video
                autoplay
                :loopposter="require('@/assets/img/jobs/social/bg1.png')"
                class="video"
                muted
                loop
              >
                <source
                  src="https://res.cote.3songshu.com/forum/attachment/20200629/04dc4348880a4f8e9b0113543bdab79f.mp4"
                />
              </video>
            </div>
            <div class="dance">
              <img
                class="animate__animated "
                style="animation-delay: 0.4s;"
                :class="[
                  {
                    animate__bounceIn: reachIndex === 0
                  }
                ]"
                :src="require('@/assets/img/jobs/social/dance.png')"
                alt=""
              />
            </div>
            <div class="search--box">
              <div class="search--left" @click="toSearch1">
                搜索
              </div>
              <div class="search--right">
                <input
                  v-model.trim="searchPost1"
                  type="text"
                  placeholder="在此搜索心仪的职位"
                  class="search--input"
                />
                <i class="icon--search" @click="toSearch1"></i>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper--slide social--page2">
            <div class="page--title">
              <p
                class="title--english animate__animated"
                style="animation-delay: 0.2s"
                :class="[
                  {
                    animate__bounceInDown: reachIndex === 1
                  }
                ]"
              >
                TALENT CONCEPT
              </p>
              <p
                class="title--chinese animate__animated"
                style="animation-delay: 0.4s"
                :class="[
                  {
                    animate__bounceInDown: reachIndex === 1
                  }
                ]"
              >
                人才理念
              </p>
            </div>
            <div class="talent--box" ref="talentBox">
              <div class="talent--inner">
                <div class="talent--item talent--item1">
                  <div class="item--inner" ref="talentItem1">
                    <img
                      class="talent--img1"
                      :src="require('@/assets/img/jobs/social/01.png')"
                      alt=""
                    />
                    <p class="talent--text1">
                      让能折腾、耐磨损、有韧性的年轻
                      人在松鼠这个育人平台上跳舞。
                    </p>
                  </div>
                </div>
                <div ref="talentItem2" class="talent--item ">
                  <div class="item--inner" ref="talentItem2">
                    <img
                      class="talent--img2"
                      :src="require('@/assets/img/jobs/social/02.png')"
                      alt=""
                    />
                    <p class="talent--text2">
                      让平凡的人不平凡，优秀的人更优秀
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper--slide social--page3">
            <div class="welfare--box">
              <div
                class="welfare--item animate__animated"
                style="animation-delay: 0s"
                :class="[
                  {
                    animate__rotateIn: reachIndex === 2
                  }
                ]"
              >
                <div class="item--before">
                  <div class="item--center">
                    松
                  </div>
                </div>
                <div class="item--after">
                  <div
                    class="after--bg"
                    :style="{
                      backgroundImage:
                        'url(' +
                        require('@/assets/img/jobs/social/welfare/1.png') +
                        ')'
                    }"
                  ></div>
                  <div class="after--inner">
                    <p><span>六险一金：</span>闯荡社会的坚实盾牌</p>
                    <p><span>CEO与家长们基金：</span>松鼠大家庭的专属保障</p>
                    <p><span>年度体检：</span>为鼠员健康保驾护航</p>
                    <p><span>新人礼包：</span>欢迎加入松鼠大家庭</p>
                  </div>
                </div>
              </div>
              <div
                class="welfare--item animate__animated"
                style="animation-delay: 0.2s"
                :class="[
                  {
                    animate__rotateIn: reachIndex === 2
                  }
                ]"
              >
                <div class="item--before">
                  <div class="item--center">
                    鼠
                  </div>
                </div>
                <div class="item--after">
                  <div
                    class="after--bg"
                    :style="{
                      backgroundImage:
                        'url(' +
                        require('@/assets/img/jobs/social/welfare/2.png') +
                        ')'
                    }"
                  ></div>
                  <div class="after--inner">
                    <p><span>松鼠公寓：</span>给你一个安心的住所</p>
                    <p><span>节日礼包：</span>把爱带回家</p>
                    <p><span>晚间福利：</span>填饱肚子才有力气加班</p>
                    <p><span>专享折扣：</span>买给你喜欢的亲朋好友</p>
                  </div>
                </div>
              </div>
              <div
                class="welfare--item animate__animated"
                style="animation-delay: 0.4s"
                :class="[
                  {
                    animate__rotateIn: reachIndex === 2
                  }
                ]"
              >
                <div class="item--before">
                  <div class="item--center">
                    福
                  </div>
                </div>
                <div class="item--after">
                  <div
                    class="after--bg"
                    :style="{
                      backgroundImage:
                        'url(' +
                        require('@/assets/img/jobs/social/welfare/3.png') +
                        ')'
                    }"
                  ></div>
                  <div class="after--inner">
                    <p><span>生日祝福：</span>见证你成长的欢乐</p>
                    <p><span>团队基金：</span>体验集体文化</p>
                    <p><span>松鼠家庭日：</span>关注小家庭的成长与幸福</p>
                    <p><span>派驻福利：</span>走到哪里都带着松鼠的一丝牵挂</p>
                  </div>
                </div>
              </div>
              <div
                class="welfare--item animate__animated"
                style="animation-delay: 0.6s"
                :class="[
                  {
                    animate__rotateIn: reachIndex === 2
                  }
                ]"
              >
                <div class="item--before">
                  <div class="item--center">
                    利
                  </div>
                </div>
                <div class="item--after">
                  <div
                    class="after--bg"
                    :style="{
                      backgroundImage:
                        'url(' +
                        require('@/assets/img/jobs/social/welfare/4.png') +
                        ')'
                    }"
                  ></div>
                  <div class="after--inner">
                    <p><span>鼠味相投：</span>小资生活的味蕾体验</p>
                    <p><span>松鼠社团：</span>寻找遥远的相似性</p>
                    <p><span>松鼠身份仪式：</span>以传承为使命</p>
                    <p><span>松鼠假期：</span>享受时光的能量补给</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="welfare--tip">
              <span
                class="animate__animated"
                style="animation-delay: 0ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >更</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 50ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >多</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 100ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >福</span
              >
              <span
                class="animate__animated"
                style="animation-delay:150ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >利</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 200ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >在</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 250ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >松</span
              >
              <span
                class="animate__animated"
                style="animation-delay:300ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >鼠</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 350ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >王</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 400ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >国</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 450ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >等</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 500ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >主</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 550ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >人</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 600ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >体</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 650ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >验</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 700ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >哦</span
              >
              <span
                class="animate__animated"
                style="animation-delay: 750ms"
                :class="[
                  {
                    animate__bounceInUp: reachIndex === 2
                  }
                ]"
                >~</span
              >
            </div>
          </swiper-slide>
          <swiper-slide class="swiper--slide social--page4">
            <div class="dev--box" @mouseleave="onDev()">
              <div class="dev--before">
                <img
                  :src="require('@/assets/img/jobs/social/dev.png')"
                  alt=""
                />
              </div>
              <div class="dev--after" :class="[devAfterClass]">
                <img
                  :src="require('@/assets/img/jobs/social/dev1.png')"
                  alt=""
                />
              </div>
              <div class="dev--steps">
                <div class="dev--step d1" @mouseenter="onDev('d1')"></div>
                <div class="dev--step d2" @mouseenter="onDev('d2')"></div>
                <div class="dev--step d3" @mouseenter="onDev('d3')"></div>
                <div class="dev--step d4" @mouseenter="onDev('d4')"></div>
                <div class="dev--step d5" @mouseenter="onDev('d5')"></div>
                <div class="dev--step d6" @mouseenter="onDev('d6')"></div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper--slide social--page5">
            <div class="activity--tabs">
              <div
                class="tab--item"
                :class="{
                  on: [0, 1, 2, 3].includes(activityIndex % 16)
                }"
                @click="toActivitySwiper(0)"
              >
                双十一狂欢节
              </div>
              <div
                class="tab--item"
                :class="{ on: [4, 5, 6, 7].includes(activityIndex % 16) }"
                @click="toActivitySwiper(4)"
              >
                松鼠家庭日
              </div>
              <div
                class="tab--item"
                :class="{ on: [8, 9, 10, 11].includes(activityIndex % 16) }"
                @click="toActivitySwiper(8)"
              >
                619周年庆
              </div>
              <div
                class="tab--item"
                :class="{ on: [12, 13, 14, 15].includes(activityIndex % 16) }"
                @click="toActivitySwiper(12)"
              >
                廉洁活动
              </div>
              <div class="tab--more">>></div>
            </div>
            <div class="activity--swiper">
              <swiper ref="activitySwiper" :options="swiperOptionActivity">
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t1/1.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image2">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t1/2.png')"
                      alt=""
                    />
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t1/3.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image2">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t1/4.png')"
                      alt=""
                    />
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t1/5.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t1/6.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t2/1.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t2/2.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t2/3.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t2/4.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t3/1.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t3/2.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t3/3.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t3/4.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t4/1.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t4/2.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t4/3.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide class="activity--item">
                  <div class="activity--image">
                    <img
                      :src="require('@/assets/img/jobs/social/ac/t4/4.png')"
                      alt=""
                    />
                  </div>
                </swiper-slide>
              </swiper>

              <div class="activity--next">
                <div class="next--num">
                  <span class="num">
                    0{{ Math.floor((activityIndex % 16) / 4) + 1 }}
                  </span>
                </div>
                <div
                  @click="
                    toActivitySwiper(
                      (Math.floor((activityIndex % 16) / 4) * 4 + 4) % 16
                    )
                  "
                  class="next--arrow"
                ></div>
              </div>
            </div>
          </swiper-slide>

          <swiper-slide class="swiper--slide social--page6">
            <div class="page--title">
              <p
                class="title--english animate__animated"
                style="animation-delay: 0.2s"
                :class="[
                  {
                    animate__bounceInDown: reachIndex === 5
                  }
                ]"
              >
                SOCIAL RECRUITMENT
              </p>
              <p
                class="title--chinese animate__animated"
                style="animation-delay: 0.4s"
                :class="[
                  {
                    animate__bounceInDown: reachIndex === 5
                  }
                ]"
              >
                社招岗位
              </p>
            </div>
            <div class="post--box">
              <swiper class="post--swiper" :options="swiperOptionPost">
                <swiper-slide
                  :key="'post_' + index"
                  class="post--slide"
                  v-for="(item, index) in postList"
                >
                  <div class="post--item" @click="openUrl(item.url)">
                    <div class="post--icon">
                      <img
                        :src="
                          require('@/assets/img/jobs/social/post/' +
                            item.img +
                            '.png')
                        "
                        :alt="item.name"
                      />
                    </div>
                    <div class="post--name">{{ item.name }}</div>
                  </div>
                </swiper-slide>
              </swiper>
              <div class="post-prev"></div>
              <div class="post-next"></div>
            </div>
            <div class="post--search">
              <input
                v-model.trim="searchPost2"
                class="post--input"
                placeholder="在此搜索心仪职位"
                type="text"
              />
              <i class="icon--post--search" @click="toSearch2"></i>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="footer" :class="{ on: reachIndex === 5 }">
        <div class="footer--inner">
          <div class="footer--left">
            <div class="footer--row qrcode--box">
              <span>关注三只松鼠招聘官方账号</span>
              <div class="qrcode--list">
                <div class="qrcode--wrap">
                  <img
                    class="qrcode--icon"
                    :src="
                      require('@/assets/img/jobs/school/qrcode/icon-weixin.png')
                    "
                    alt=""
                  />
                  <div class="qrcode--border">
                    <p class="qrcode--title">关注三只松鼠招聘微信公众号</p>
                    <img
                      class="qrcode--img"
                      :src="
                        require('@/assets/img/jobs/school/qrcode/qrcode-weixin.png')
                      "
                      alt=""
                    />
                  </div>
                </div>

                <div class="qrcode--wrap">
                  <img
                    class="qrcode--icon"
                    :src="
                      require('@/assets/img/jobs/school/qrcode/icon-weibo.png')
                    "
                    alt=""
                  />
                  <div class="qrcode--border">
                    <p class="qrcode--title">关注三只松鼠招聘微博公众号</p>
                    <img
                      class="qrcode--img"
                      :src="
                        require('@/assets/img/jobs/school/qrcode/qrcode-weibo.png')
                      "
                      alt=""
                    />
                  </div>
                </div>

                <div class="qrcode--wrap">
                  <img
                    class="qrcode--icon"
                    :src="
                      require('@/assets/img/jobs/school/qrcode/icon-douyin.png')
                    "
                    alt=""
                  />
                  <div class="qrcode--border">
                    <p class="qrcode--title">关注三只松鼠招聘抖音公众号</p>
                    <img
                      class="qrcode--img"
                      :src="
                        require('@/assets/img/jobs/school/qrcode/qrcode-douyin.png')
                      "
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="footer--row">
              招聘邮箱： h_ssxz@3songshu.com
            </div>
          </div>
          <div class="footer--right">
            <div class="footer--right--label">
              <div class="footer--row">松鼠窝地址：</div>
            </div>
            <div class="footer--right--content">
              <div class="footer--row">
                安徽省芜湖市弋江区高新技术产业开发区久盛路8号
              </div>
              <div class="footer--row">
                江苏省南京市鼓楼区集庆门大街268号苏宁慧谷中心E07-2-40F
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 左侧边nav -->
      <div
        class="nav--sidebar"
        :class="{ on: [1, 2, 3, 4].includes(reachIndex) }"
      >
        <div
          @click="toFullPageSwiper(1)"
          class="side--item"
          :class="{ on: [1].includes(reachIndex) }"
        >
          人才理念
        </div>
        <div
          @click="toFullPageSwiper(2)"
          class="side--item"
          :class="{ on: [2].includes(reachIndex) }"
        >
          松鼠福利
        </div>
        <div
          @click="toFullPageSwiper(3)"
          class="side--item"
          :class="{ on: [3].includes(reachIndex) }"
        >
          晋升发展
        </div>
        <div
          @click="toFullPageSwiper(4)"
          class="side--item"
          :class="{ on: [4].includes(reachIndex) }"
        >
          松鼠活动
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import animated from "animate.css";
Vue.use(animated);
export default {
  name: "jobs-school",
  data() {
    return {
      devAfterClass: "",
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
      slideStyle: {
        width: document.body.clientWidth + "px",
        height: document.body.clientHeight + "px"
      },
      swiperOption: {
        direction: "vertical",
        mousewheel: true,
        keyboardControl: true,
        mousewheelControl: true,
        simulateTouch: false,
        createPagination: false,
        paginationClickable: true,
        speed: 700,
        initialSlide: 0,
        on: {
          slideChange: () => {
            this.fullPageSlideChange();
          }
        }
      },
      swiperOptionPost: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        initialSlide: 3,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        navigation: {
          prevEl: ".post-prev",
          nextEl: ".post-next"
        }
      },
      swiperOptionActivity: {
        slidesPerView: "auto",
        spaceBetween: 6,
        speed: 2000,
        autoplay: {
          delay: 1500,
          disableOnInteraction: false
        },
        on: {
          slideChange: () => {
            let swiper = this.$refs.activitySwiper.$swiper;
            if (swiper) {
              this.activityIndex = swiper.activeIndex;
            }
          }
        }
      },
      activityIndex: 0,
      reachIndex: 0,
      searchPost1: "",
      searchPost2: "",
      postList: [
        {
          img: "kefu",
          name: "客服类",
          url:
            "https://app.mokahr.com/apply/3songshu/458#/jobs?zhineng=15857&page=1"
        },
        {
          img: "wuliu",
          name: "供应链/物流类",
          url:
            "https://app.mokahr.com/apply/3songshu/458#/jobs?zhineng=13988&page=1"
        },
        {
          img: "shengchan",
          name: "生产/制造类",
          url:
            "https://app.mokahr.com/apply/3songshu/458#/jobs?zhineng=6595&page=1"
        },
        {
          img: "zhineng",
          name: "职能类",
          url:
            "https://app.mokahr.com/apply/3songshu/458#/jobs?zhineng=6593&page=1"
        },
        {
          img: "jishu",
          name: "技术类",
          url:
            "https://app.mokahr.com/apply/3songshu/458#/jobs?zhineng=6588&page=1"
        },
        {
          img: "mendian",
          name: "线下门店类",
          url:
            "https://app.mokahr.com/apply/3songshu/458#/jobs?zhineng=16508&page=1"
        },
        {
          img: "yunying",
          name: "运营/销售类",
          url:
            "https://app.mokahr.com/apply/3songshu/458#/jobs?zhineng=6591&page=1"
        },
        {
          img: "sheji",
          name: "创意/设计类",
          url:
            "https://app.mokahr.com/apply/3songshu/458#/jobs?zhineng=6590&page=1"
        },
        {
          img: "chanping",
          name: "产品/质量类",
          url:
            "https://app.mokahr.com/apply/3songshu/458#/jobs?zhineng=6589&page=1"
        }
      ],
      talentMoveStyle1: {}
    };
  },
  methods: {
    initData() {
      this.slideStyle = {
        width: document.body.clientWidth + "px",
        height: document.body.clientHeight + "px"
      };
    },
    // 跳转fullpage index
    toFullPageSwiper(v) {
      let swiper = this.$refs.fullPageSwiper.$swiper;
      if (swiper) {
        swiper.slideTo(v, 1000, false);
      }
    },
    toSearch1() {
      let searchPost = this.searchPost1.trim();
      let url =
        "https://app.mokahr.com/apply/3songshu/458#/jobs?zhineng=&keyword=" +
        searchPost +
        "&page=1";
      window.open(url);
    },
    toSearch2() {
      let searchPost = this.searchPost2.trim();
      let url =
        "https://app.mokahr.com/apply/3songshu/458#/jobs?zhineng=&keyword=" +
        searchPost +
        "&page=1";
      window.open(url);
    },
    openUrl(url) {
      window.open(url);
    },
    onDev(v) {
      this.devAfterClass = v;
    },
    toActivitySwiper(v) {
      let swiper = this.$refs.activitySwiper.$swiper;
      if (swiper) {
        swiper.slideTo(v, 1000, false);
      }
    },
    fullPageSlideChange() {
      let swiper = this.$refs.fullPageSwiper.$swiper;
      if (swiper) {
        let activeIndex = swiper.activeIndex;
        this.reachIndex = activeIndex;
        if (activeIndex === 1) {
          this.onMousemove();
        } else {
          this.onMouseUp();
        }
      }
    },
    onMouseUp() {
      document.onmousemove = null;
    },
    onMousemove() {
      this.initPage2MouseMove();
    },
    initPage2MouseMove() {
      let ref = this.$refs.talentBox;
      document.onmousemove = e => {
        if (this.reachIndex !== 1) return false;
        const w = this.screenWidth;
        const h = this.screenHeight;
        // 获取拖拽移动的距离
        const x = e.clientX;
        const y = e.clientY;
        let mx = x - w / 2;
        let my = y - h / 2;
        this.$refs.talentItem1.style.left = mx / 300 + "px";
        this.$refs.talentItem1.style.top = my / 200 + "px";
        this.$refs.talentItem2.style.left = mx / 300 + "px";
        this.$refs.talentItem2.style.top = my / 200 + "px";
      };
    }
  },
  mounted() {
    this.initData();
    this.screenWidth = document.body.clientWidth;
    this.screenHeight = document.body.clientHeight;
    window.onresize = () => {
      return (() => {
        let clientWidth = document.body.clientWidth;
        if (clientWidth <= 1200) {
          clientWidth = 1200;
        }
        this.screenWidth = clientWidth;
        this.screenHeight = document.body.clientHeight;
      })();
    };
    this.initPage2MouseMove();
  }
};
</script>

<style scoped lang="less">
@import "./jobs-social.less";
</style>
